<div class="popover-container">
    <ng-content></ng-content>

    <button nbButton status="primary" class="ml-2" (click)="apply()" [disabled]="disableSubmit">
        {{ submitBtnLabel }}
    </button>
</div>
